import React, { useState, useEffect } from "react";
import ApproveFormManager from "./ApproveFormManager";
import {
  getAllTimesheetsByFilter,
  generateReportApi,
  updateTimesheetProcessData,
} from "./helper/coreapicalls";
import Pagination from "./Pagination"; // Import the Pagination component
import DetailedUserView from "./DetailedUserView";
import TimesheetSearch from "./TimesheetSearch";

import { toast, ToastContainer } from "react-toastify"; // Import toast
import "react-toastify/dist/ReactToastify.css"; // Import CSS

const TeamLeadControl = () => {
  const [expandedId, setExpandedId] = useState(null);

  const [selectedTimesheet, setSelectedTimesheet] = useState(null);
  const [selectedTimesheetView, setSelectedTimesheetView] = useState(null);
  const [timesheetsData, setTimesheetsData] = useState([]);
  // const [alltimesheetsData, setAllTimesheetsData] = useState([]);

  const [alltimesheetsData, setAllTimesheetsData] = useState({
    timesheetsData: [],
    count: 0,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({});

  const handleSearch = async (searchFilters) => {
    console.log("searchFilters", searchFilters);
    setFilters(searchFilters);

    setCurrentPage(1);
    await fetchTimesheets(1, searchFilters);
  };

  const handleReportGen = async (searchFilters) => {
    setFilters(searchFilters);
    setCurrentPage(1);
    await generateReport(1, searchFilters);
  };

  useEffect(() => {
    fetchTimesheets(currentPage, filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchTimesheets = async (page = 1, searchFilters = filters) => {
    try {
      console.log("fetchTimesheets called with filters:", searchFilters);
      setLoading(true);
      let managerFilter = null;
      let tlFilter = null;
      if (searchFilters.teamlead === "true") {
        tlFilter = true;
      } else if (searchFilters.teamlead === "false") {
        tlFilter = false;
      } else if (searchFilters.teamlead === "all") {
        tlFilter = null;
      }

      if (searchFilters.manager === "true") {
        managerFilter = true;
      } else if (searchFilters.manager === "false") {
        managerFilter = false;
      } else if (searchFilters.manager === "all") {
        managerFilter = null;
      }

      const result = await getAllTimesheetsByFilter(
        tlFilter,
        managerFilter,
        searchFilters.sr === true ? searchFilters.sr : null,
        searchFilters.teamId && searchFilters.teamId.team_id
          ? searchFilters.teamId.team_id
          : null,
        searchFilters.branchId && searchFilters.branchId.branch_id
          ? searchFilters.branchId.branch_id
          : null,
        page,
        searchFilters.msid,
        searchFilters.eng_name,
        searchFilters.vessel_name,
        searchFilters.startdate,
        searchFilters.enddate,
        searchFilters.Job_No,
        searchFilters.OT === true ? searchFilters.OT : null,
        false,
        searchFilters.Flag === true ? searchFilters.Flag : null,
      );
      // console.log("searchFilters.Flag", searchFilters.Flag);
      // console.log("result data", result.timesheetsData);
      setAllTimesheetsData(result);
      setTimesheetsData(result.timesheetsData);
      setTotalPages(Math.ceil(result.count / 100));
      setLoading(false);
    } catch (error) {
      console.error("Error fetching timesheet data:", error);
      setLoading(false);
    }
  };

  const generateReport = async (page = 1, searchFilters = filters) => {
    try {
      setLoading(true);

      let managerFilter = null;
      let tlFilter = null;
      if (searchFilters.teamlead === "true") {
        tlFilter = true;
      } else if (searchFilters.teamlead === "false") {
        tlFilter = false;
      } else if (searchFilters.teamlead === "all") {
        tlFilter = null;
      }

      if (searchFilters.manager === "true") {
        managerFilter = true;
      } else if (searchFilters.manager === "false") {
        managerFilter = false;
      } else if (searchFilters.manager === "all") {
        managerFilter = null;
      }

      const result = await generateReportApi(
        tlFilter,
        managerFilter,
        searchFilters.sr === true ? searchFilters.sr : null,
        searchFilters.teamId && searchFilters.teamId.team_id
          ? searchFilters.teamId.team_id
          : null,
        searchFilters.branchId && searchFilters.branchId.branch_id
          ? searchFilters.branchId.branch_id
          : null,
        page,
        searchFilters.msid,
        searchFilters.eng_name,
        searchFilters.vessel_name,
        searchFilters.startdate,
        searchFilters.enddate,
        searchFilters.Job_No,
        searchFilters.OT === true ? searchFilters.OT : null,
        false,
        searchFilters.Flag === true ? searchFilters.Flag : null,

      );
      downloadFileFromResult(result);
      // setAllTimesheetsData(result.timesheetsData);
      // setTotalPages(Math.ceil(result.count / 100));
      setLoading(false);
    } catch (error) {
      console.error("Error fetching timesheet data:", error);
      setLoading(false);
    }
  };

  const downloadFileFromResult = ({ blob, headers }) => {
    // Create a new Blob object using the response data (the Excel file)
    const fileBlob = new Blob([blob], { type: headers.get("content-type") });

    // Create a temporary anchor element to trigger the download
    const url = window.URL.createObjectURL(fileBlob);
    const link = document.createElement("a");
    link.href = url;

    // Get the filename from the Content-Disposition header if available
    const contentDisposition = headers.get("content-disposition");
    let fileName = "downloaded_file.xlsx"; // Default filename
    if (contentDisposition && contentDisposition.includes("filename=")) {
      fileName = contentDisposition
        .split("filename=")[1]
        .split(";")[0]
        .replace(/"/g, ""); // Extract the filename
    }

    // Set the file name for the downloaded file
    link.setAttribute("download", fileName);

    // Append the link to the document body and click it to start the download
    document.body.appendChild(link);
    link.click();

    // Clean up and remove the link
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const normalUserfilterConfig = [
    { type: "text", name: "msid", label: "MSID" },
    { type: "text", name: "eng_name", label: "Eng_Name" },
    { type: "text", name: "vessel_name", label: "Vessel_Name" },
    { type: "text", name: "Job_No", label: "Job_No" },
    { type: "date", name: "startdate", label: "Start" },
    { type: "date", name: "enddate", label: "End" },
    { type: "select", name: "Team", label: "Team" },
    { type: "select", name: "Branch", label: "Branch" },
    { type: "checkbox", name: "OT", label: "Overtime" },
    // { type: "checkbox", name: "teamlead", label: "Teamlead" },
    {
      type: "customSelect",
      name: "teamlead",
      label: "Teamlead",
      options: [
        { value: "all", label: "All" },
        { value: "true", label: "Approved" },
        { value: "false", label: "Not Approved" },
      ],
    },
    // { type: "checkbox", name: "manager", label: "Manager" },
    {
      type: "customSelect",
      name: "manager",
      label: "Manager",
      options: [
        { value: "all", label: "All" },
        { value: "true", label: "Approved" },
        { value: "false", label: "Not Approved" },
      ],
    },
    { type: "checkbox", name: "sr", label: "SR" },
    { type: "checkbox", name: "Flag", label: "Flag" },
  ];

  const loadingMessage = () => {
    return (
      loading && (
        <div className="overlay">
          <div className="d-flex justify-content-center align-items-center vh-100">
            <div className="spinner-border text-danger" role="status"></div>
          </div>
        </div>
      )
    );
  };

  const handleViewClick = (timesheet) => {
    setSelectedTimesheetView(timesheet);
    // console.log("selected timesheet", timesheet);
  };
  const handleEditClick = (timesheet) => {
    setSelectedTimesheet(timesheet);
  };

  function decimalToTime(decimalHours) {
    // Split the decimal into hours and minutes
    var hours = Math.floor(decimalHours);
    var minutes = Math.round((decimalHours - hours) * 60);

    // Format the time
    var formattedTime = hours + ":" + (minutes < 10 ? "0" : "") + minutes;

    return formattedTime;
  }
  const handleSaveEdit = (editedTimesheet) => {
    setTimesheetsData((prevData) =>
      prevData.map((timesheet) =>
        timesheet.timesheet_id === editedTimesheet.timesheet_id
          ? editedTimesheet
          : timesheet,
      ),
    );
    setSelectedTimesheet(null);
  };
  const handleCloseEdit = () => {
    setSelectedTimesheet(null);
  };
  const handleCloseView = () => {
    setSelectedTimesheetView(null);
  };
  const handleNextPage = async (newPage) => {
    setCurrentPage(newPage);
    await fetchTimesheets(newPage, filters);
  };

  const handleProcessClick = async (timesheet) => {
    try {
      setLoading(true);

      // Optimistic Update (Optional):
      setTimesheetsData((prevData) =>
        prevData.map((item) =>
          item.timesheet_id === timesheet.timesheet_id
            ? {
                ...timesheet,
                timesheet_dept_manager_approve:
                  !timesheet.timesheet_dept_manager_approve,
              }
            : item,
        ),
      );

      const updatedTimesheet = { ...timesheet };
      updatedTimesheet.timesheet_dept_manager_approve =
        !timesheet.timesheet_dept_manager_approve;
      const jsonData = {
        timesheet_dept_manager_approve:
          updatedTimesheet.timesheet_dept_manager_approve,
      };

      await updateTimesheetProcessData(timesheet.timesheet_id, jsonData);

      setLoading(false);

      // Show success toast notification
      toast.success("Timesheet updated successfully!", {
        position: "top-right", // Adjust position as needed
        autoClose: 3000,
        pauseOnFocusLoss: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } catch (error) {
      console.error("Error updating timesheet:", error);
      setLoading(false);

      // Revert Optimistic Update if API call fails (Optional):
      setTimesheetsData((prevData) =>
        prevData.map((item) =>
          item.timesheet_id === timesheet.timesheet_id
            ? {
                ...timesheet,
                timesheet_dept_manager_approve:
                  timesheet.timesheet_dept_manager_approve,
              }
            : item,
        ),
      );

      toast.error("Error updating timesheet. Please try again.", {
        // Show error toast
        position: "top-right",
        autoClose: 3000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

const stickyColStyle = {
  position: 'sticky',
  zIndex: 5,
  borderRight: '1px solid #dee2e6',
};

return (
  <div className="container-fluid p-3">
    {/* Global Notifications */}
    {loadingMessage()}
    <ToastContainer />

    {/* Header Section */}
    <div className="d-flex flex-wrap align-items-center justify-content-between mb-3 gap-2">
      <div className="flex-grow-1">
        <TimesheetSearch
          initialConfig={normalUserfilterConfig}
          onSearch={handleSearch}
          onReportGen={handleReportGen}
        />
      </div>
      
      <div className="card border-left-primary shadow-sm" style={{ width: 180, backgroundColor: "Indigo" }}>
        <div className="card-body p-2 text-center">
          <div className="text-white small font-weight-bold">
            Result Count: {alltimesheetsData.count}
          </div>
        </div>
      </div>
    </div>

    {/* Table Section */}
    <div className="card shadow-lg mb-4">
      <div 
        className="table-responsive" 
        style={{ maxHeight: "600px", overflowY: "auto", overflowX: "auto" }}
      >
        <table 
          className="table table-hover table-striped align-middle mb-0" 
          style={{ 
            borderCollapse: 'separate', 
            borderSpacing: 0, 
            width: '100%' 
          }}
        >
          <thead className="sticky-top" style={{ zIndex: 40 }}>
            <tr className="text-center small font-weight-bold bg-light" style={{ fontSize: '11px', textTransform: 'uppercase' }}>
              {/* Sticky Headers */}
              <th style={{ ...stickyColStyle, left: 0, width: '50px', minWidth: '50px', zIndex: 41, backgroundColor: '#f8f9fa' }}>View</th>
              <th style={{ ...stickyColStyle, left: 50, width: '50px', minWidth: '50px', zIndex: 41, backgroundColor: '#f8f9fa' }}>Edit</th>
              <th style={{ ...stickyColStyle, left: 100, width: '100px', minWidth: '100px', zIndex: 41, backgroundColor: '#f8f9fa' }}>TS Date<br/>y-m-d</th>
              <th style={{ ...stickyColStyle, left: 200, width: '150px', minWidth: '150px', zIndex: 41, backgroundColor: '#f8f9fa', boxShadow: '2px 0 5px -2px rgba(0,0,0,0.2)' }}>Eng Name</th>
              
              {/* Scrollable Headers */}
              <th style={{ minWidth: '100px' }}>Created At</th>
              <th style={{ maxWidth: "100px" }}>Start Time</th>
              <th style={{ maxWidth: "80px" }}>Sign In</th>
              <th style={{ maxWidth: "80px" }}>Sign Out</th>
              <th style={{ maxWidth: "80px" }}>Return</th>
              <th style={{ minWidth: "70px" }}>Normal Hrs</th>
              <th style={{ minWidth: "60px" }}>Total Hrs</th>
              <th style={{ minWidth: "60px" }}>OT Hrs</th>
              <th style={{ maxWidth: "80px" }}>Exp. OT</th>
              <th style={{ maxWidth: "80px" }}>OT Amt</th>
              <th style={{ maxWidth: "90px" }}>Alw.Amt</th>
              <th style={{ maxWidth: "80px" }}>Total</th>
              <th style={{ maxWidth: "60px" }}>H.day</th>
              <th style={{ maxWidth: "60px" }}>Anch</th>
              <th style={{ maxWidth: "60px" }}>OS</th>
              <th style={{ maxWidth: "60px" }}>DryD</th>
              <th style={{ maxWidth: "60px" }}>Team Lead</th>
              <th style={{ maxWidth: "60px" }}>Dept Mgr</th>
              <th style={{ maxWidth: "60px" }}>Final Status</th>
              <th style={{ maxWidth: "70px" }}>Process Status</th>
              <th className="text-danger" style={{ maxWidth: "80px" }}>Flag Reason</th>
              <th style={{ maxWidth: "100px" }}>Comments</th>
            </tr>
          </thead>
          
          <tbody className="small">
            {timesheetsData?.map((timesheet) => {
              const isApproved = timesheet.timesheet_dept_manager_approve;
              const rowBg = isApproved ? "#d1e7dd" : "#ffffff";

              // Formatting Logic for Created At
              const createdAtDate = new Date(timesheet.timesheet_created_at);
              const formattedDate = createdAtDate.toLocaleDateString('en-US', {
                month: 'short',
                day: '2-digit',
                year: 'numeric'
              });
              const formattedTime = createdAtDate.toLocaleTimeString('en-GB', {
                hour: '2-digit',
                minute: '2-digit'
              });

              return (
                <tr 
                style={{ fontSize: '11px' }}
                  key={timesheet.timesheet_id}
                  className={`text-center ${timesheet.is_flagged ? "danger-extreme" : ""} ${isApproved ? "table-success" : ""}`}
                >
                  {/* Sticky Data Cells */}
                  <td style={{ ...stickyColStyle, left: 0, width: '50px', minWidth: '50px', backgroundColor: rowBg }}>
                    <div className="d-flex justify-content-center align-items-center gap-1">
                      <button className="btn btn-sm text-primary p-1" onClick={() => handleViewClick(timesheet)}><i className="fa fa-eye"></i></button>
                      {timesheet.timesheet_attendance_id?.attendance_sr_upload_location && (
                        <a href={timesheet.timesheet_attendance_id.attendance_sr_upload_location} target="_blank" rel="noopener noreferrer" className="btn btn-sm text-primary p-1">
                          <i className="fa-solid fa-file"></i>
                        </a>
                      )}
                    </div>
                  </td>
                  <td style={{ ...stickyColStyle, left: 50, width: '50px', minWidth: '50px', backgroundColor: rowBg }}>
                    <button className="btn btn-sm text-primary p-1" onClick={() => handleEditClick(timesheet)}><i className="fa fa-edit"></i></button>
                  </td>
                  <td style={{ ...stickyColStyle, left: 100, width: '100px', minWidth: '100px', backgroundColor: rowBg }}>{timesheet.timesheet_date}</td>
                  <td style={{ ...stickyColStyle, left: 200, width: '150px', minWidth: '150px', backgroundColor: rowBg, boxShadow: '2px 0 5px -2px rgba(0,0,0,0.2)' }}>{timesheet.emp_name}</td>

                  {/* New Created At Column with two-line formatting */}
                  <td>
                    <div className="font-weight-bold">{formattedDate}</div>
                    <div className="text-muted" style={{ fontSize: '10px' }}>{formattedTime}</div>
                  </td>

                  {/* Other Data Cells */}
                  <td>{timesheet.timesheet_time_start}</td>
                  <td>{timesheet.timesheet_time_signin}</td>
                  <td>{timesheet.timesheet_time_signout}</td>
                  <td>{timesheet.timesheet_time_return}</td>
                  <td>{decimalToTime(timesheet.timesheet_normal_hours)}</td>
                  <td>{decimalToTime(timesheet.timesheet_total_hours)}</td>
                  <td>{decimalToTime(timesheet.timesheet_over_time_hours)}</td>
                  <td>{timesheet.timesheet_expected_amount}</td>
                  <td>{timesheet.timesheet_overtime_amount}</td>
                  <td>{timesheet.timesheet_allowance_amount}</td>
                  <td className="fw-bold">{timesheet.timesheet_Total_amount}</td>

                  <td><i className={`fa ${timesheet.timesheet_is_holiday ? "fa-check text-success" : "fa-times text-secondary"}`}></i></td>
                  <td><i className={`fa ${timesheet.timesheet_attendance_id?.attendance_is_anchorage ? "fa-check text-success" : "fa-times text-secondary"}`}></i></td>
                  <td><i className={`fa ${timesheet.timesheet_attendance_id?.attendance_is_overseas ? "fa-check text-success" : "fa-times text-secondary"}`}></i></td>
                  <td><i className={`fa ${timesheet.timesheet_attendance_id?.attendance_is_dubaidrydock ? "fa-check text-success" : "fa-times text-secondary"}`}></i></td>

                  <td><span className={`badge ${timesheet.timesheet_teamlead_approve ? "bg-success" : "bg-warning text-dark"}`}><i className={`fa-solid ${timesheet.timesheet_teamlead_approve ? "fa-thumbs-up" : "fa-thumbs-down"}`}></i></span></td>
                  <td>
                    <button disabled={!timesheet.timesheet_total_hours && timesheet.timesheet_total_hours !== 0} className={`btn btn-sm ${isApproved ? "btn-success" : "btn-warning text-dark"}`} onClick={() => handleProcessClick(timesheet)} style={{ padding: "2px 8px", fontSize: "10px" }}>
                      <i className={`fa-solid ${isApproved ? "fa-thumbs-up" : "fa-thumbs-down"}`}></i>
                    </button>
                  </td>

                  <td><span className={`badge border ${!isApproved ? "border-danger text-danger" : "border-success text-success"}`} style={{ fontSize: '10px' }}>{!isApproved ? "Waiting" : "Completed"}</span></td>
                  <td><span className={`badge border ${!timesheet.timesheet_final_process_status ? "border-danger text-danger" : "border-success text-success"}`} style={{ fontSize: '10px' }}>{!timesheet.timesheet_final_process_status ? "Waiting" : "Completed"}</span></td>

                  <td onClick={() => setExpandedId(expandedId === timesheet.timesheet_id ? null : timesheet.timesheet_id)} style={{ maxWidth: '180px', cursor: 'pointer', ...(expandedId === timesheet.timesheet_id ? { whiteSpace: 'normal', wordBreak: 'break-word', backgroundColor: 'rgba(0,0,0,0.05)' } : { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }) }}>
                    {timesheet.flag_reason || ""}
                  </td>
                  <td>{timesheet.timesheet_comments}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>

    <Pagination currentPage={currentPage} totalPages={totalPages} onNextPage={() => handleNextPage(currentPage + 1)} onPrevPage={() => handleNextPage(currentPage - 1)} />

    {selectedTimesheet && <ApproveFormManager timesheet={selectedTimesheet} onUpdate={handleSaveEdit} onClosePopup={handleCloseEdit} />}
    {selectedTimesheetView && <DetailedUserView timesheet={selectedTimesheetView} onClosePopup={handleCloseView} />}
  </div>
);
};

export default TeamLeadControl;
